
import {watchRemoveUserSchool} from './schoolChangeSagas';

const schoolChangeSagas = [
  watchRemoveUserSchool
];

export default schoolChangeSagas;
